<div
  #mainBox
  [class.top-box]="isTopBox"
  [class.bottom-box]="isBottomBox"
  [class.data-recorded-success]="justRecorded"
  [class.data-buffer-active]="addingTargetData"
  class="duration-box pointer data-entry-box"
  (click)="inputField.focus()"
  (clickOutside)="onClickOutside()"
  [additionalElementRefs]="extraBoxes"
>
  <div
    class="flag flex-column no-select"
    [class.flag-all-trials]="remainingTrials <= 0"
    (mousedown)="startLongPress()"
    (mouseup)="endLongPress($event)"
    (mouseleave)="endLongPress($event)"
    (touchstart)="startLongPress()"
    (touchend)="endLongPress($event)"
    (touchcancel)="endLongPress($event)"
  >
    <div class="quantity-container">
      <div class="quantity-input">
        <input
          class="flag-input"
          type="number"
          [(ngModel)]="quantity"
          [placeholder]="'XX'"
          (keypress)="hitQuantity($event)"
          #inputField
          (focus)="inputField.select()"
          [autofocus]="true"
        />
        <span class="unit-text">{{ unit }}</span>
        <button class="add-button" (click)="addQuantity()" type="button">
          Add
        </button>
      </div>
      <div class="flag-text">
        {{ text }}

        <span class="sd-text">{{ target?.DiscriminativeStimulus }}</span>
      </div>
    </div>
    <span
      class="badge-count"
      (click)="showExtra()"
      [class.badge-count-green]="quantities.length >= expectedAmount"
      [class.badge-count-red]="quantities.length < expectedAmount"
      >{{ quantities.length }}/{{ expectedAmount }}</span
    >

    <button class="badge-bottom-left" [class.target-note-new]="target?.HasUnreadTargetNoteForStaff" (click)="openDetails($event)">?</button>
    <button
      class="badge-bottom-right"
      (click)="openDetails($event)"
      title="Remaining desired Trials"
      *ngIf="remainingTrials > 0"
    >
      {{ remainingTrials }}
    </button>
  </div>
  <div
    class="data-entry-cooldown-bar"
    [class.data-entry-cooldown-active]="addingTargetData"
    aria-hidden="true"
  >
    <div class="data-entry-cooldown-bar-fill"></div>
  </div>
</div>

@if (detailsOpened) {
<app-target-details
  [target]="target"
  (onCloseDetails)="onCloseDetails()"
  [isPreview]="isPreview"
></app-target-details>
}

<div class="extra-container" #extraBox [class.hide]="!extraOpened">
  <div class="extra-close" (click)="closeExtra()">X</div>
  <div class="extra-container-textbox">
    <div *ngFor="let eachQuantity of quantities" class="extra-text">
      <div
        class="float-right extra-list-trash-icon pointer"
        (click)="deleteData(eachQuantity)"
      >
        <i class="pi pi-trash"></i>
      </div>
      <div>{{ eachQuantity.FormattedDate }}</div>
      <div>{{ eachQuantity.Quantity }} {{ unit }}</div>
    </div>
  </div>
</div>
